export const Actions = {
    FETCH_JOINED_CHANNEL_LIST: 'Channels/FETCH_JOINED_CHANNEL_LIST',
    FETCH_AVAILABLE_CHANNEL_LIST: 'Channels/FETCH_AVAILABLE_CHANNEL_LIST',
    JOIN_CHANNEL: 'Channels/JOIN_CHANNEL',
    LEAVE_CHANNEL: 'Channels/LEAVE_CHANNEL',
};

export const Mutations = {
    SET_JOINED_CHANNEL_LIST: 'Channels/SET_JOINED_CHANNEL_LIST',
    SET_AVAILABLE_CHANNEL_LIST: 'Channels/SET_AVAILABLE_CHANNEL_LIST',
    SET_SELECTED_CHANNEL: 'Channels/SET_SELECTED_CHANNEL',
};
